import { ChangeDetectionStrategy, Component, EventEmitter, Output } from "@angular/core";
import { config } from "@config";
import { TranslationService } from "@core-services/translation.service";

@Component({
	selector: "app-locked-staking-disclaimer",
	templateUrl: "./locked-staking-disclaimer.component.html",
	styleUrls: ["./locked-staking-disclaimer.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class LockedStakingDisclaimerComponent {
	@Output() onButtonClick = new EventEmitter<void>();
	private link = this.translationService.getHdLink() + config.externalPaths["staking"]["lockedStakingHdLink"];

	constructor(private readonly translationService: TranslationService) {}

	public openLink(): void {
		window.open(this.link, "_blank");
	}
}
